export default __webpack_public_path__ + "static/media/handleAndStrapPink_diffuse-min.2d376969.jpg";